export default "__VITE_ASSET__Drzdx3VG__"